import { all, call } from "redux-saga/effects"

import { listFetchingFlow } from "./list/actions"

export function* feedbacksSaga() {
  yield all([call(listFetchingFlow)])
}

export { fetchFeedbacksList } from "./list/actions"
